import React from 'react';

const NotFound = () => <h1>NO PAGE EXISTS!!!</h1>;

export default NotFound;
